(() => {
  'use strict';

  if (window.essentialsProductFocusLoaded) return;
  window.essentialsProductFocusLoaded = true;

  let session = null;
  const isOpen = (popup) => popup.classList.contains('pswp--open') || popup.classList.contains('pswp--custom-opening');
  const isVisible = (element) => {
    if (element.closest('[hidden], [inert], [aria-hidden="true"]') || !element.getClientRects().length) return false;
    // Closed native search details can retain descendant layout rectangles.
    // Only their summary is visible, so geometry alone is not an open-dialog test.
    for (let details = element.closest('details:not([open])'); details; details = details.parentElement?.closest('details:not([open])')) {
      if (!details.querySelector(':scope > summary')?.contains(element)) return false;
    }
    const style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.visibility !== 'collapse';
  };

  const cancel = () => {
    if (!session) return;
    session.observer.disconnect();
    if (session.frame !== null) window.cancelAnimationFrame(session.frame);
    if (session.openCheck !== null) window.clearTimeout(session.openCheck);
    session = null;
  };

  const anotherDialogIsOpen = (gallery) => {
    if (['js-drawer-open', 'js-drawer-open-cart', 'js-quick-view-visible', 'js-quick-view-from-cart'].some((name) => document.body.classList.contains(name))) return true;
    return Array.from(document.querySelectorAll('.pswp, [role="dialog"], dialog, [aria-modal="true"]')).some((dialog) => {
      if (dialog === gallery) return false;
      if (dialog.classList.contains('pswp')) return isOpen(dialog);
      return isVisible(dialog);
    });
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest?.('.essentials-product [data-zoom-wrapper]');
    if (!trigger || event.defaultPrevented || event.button > 0) return;
    const slider = trigger.closest('[data-product-single-media-group]')?.querySelector('[data-product-single-media-slider]');
    if (slider?.classList.contains('is-moving')) return;

    // The native product zoom uses PhotoSwipe template 0. Observe its lifecycle,
    // without replacing the native zoom, keyboard, close, or focus-trap handlers.
    const gallery = document.querySelector('.pswp');
    if (!gallery) return;
    cancel();
    const current = {trigger, gallery, url: window.location.href, opened: false, frame: null, openCheck: null, observer: null};
    current.observer = new MutationObserver(() => {
      if (session !== current) return;
      if (gallery.classList.contains('pswp--open')) current.opened = true;
      if (isOpen(gallery)) return;
      if (!current.opened) {
        cancel();
        return;
      }
      if (gallery.getAttribute('aria-hidden') === 'false') return;

      // Wait until PhotoSwipe has destroyed its hidden modal and released its trap.
      current.observer.disconnect();
      current.frame = window.requestAnimationFrame(() => {
        if (session !== current) return;
        const active = document.activeElement;
        const focusStayedInGallery = !active || active === document.body || active === document.documentElement || gallery.contains(active);
        const shouldRestore = window.location.href === current.url
          && document.visibilityState !== 'hidden'
          && trigger.isConnected && trigger.closest('.essentials-product') && isVisible(trigger)
          && gallery.isConnected && !isOpen(gallery)
          && gallery.getAttribute('aria-hidden') !== 'false'
          && !anotherDialogIsOpen(gallery) && focusStayedInGallery;
        cancel();
        if (shouldRestore) trigger.focus({preventScroll: true});
      });
    });
    session = current;
    current.observer.observe(gallery, {attributes: true, attributeFilter: ['class', 'aria-hidden']});

    // Check after the entire click dispatch. A microtask in this capture listener
    // can run before the native target listener handles real user input.
    current.openCheck = window.setTimeout(() => {
      current.openCheck = null;
      if (session === current && !isOpen(gallery)) cancel();
    }, 0);
  }, true);

  // A dismissal must never move focus back into an earlier page or history state.
  ['pagehide', 'popstate', 'hashchange'].forEach((name) => window.addEventListener(name, cancel));
})();
